"use client"
import { useRouter } from "next/router"
import Link from "next/link"
import { getMobileOperatingSystem } from "lib/func"

export default function NavbarBottom() {
  const router = useRouter()
  const { pathname } = router
  const mobileOS = getMobileOperatingSystem()

  if (!pathname.includes("notification")) {
    return null
  }
  return (
    <>
      <nav className="fixed bottom-0 w-full bg-transparent shadow-md flex justify-around py-3 px-3 h-[80px]">
        <div className="flex items-center justify-between w-full px-2 bg-[#5f5f5f] rounded-[12px] gap-2">
          <div className="flex items-center gap-2">
            <img
              src="https://cdn-img.onlivetv.vn/dev/dd753111-bb90-43b4-bb4b-115f784f09c1.png"
              alt="Logo"
              className="w-[40px]"
            />
            <div className="items-center gap-4">
              <span className="text-white text-sm font-bold">ONLive TV</span>
              <p className="text-white text-sm">Esports, Sports, Show</p>
            </div>
          </div>
          <div className="flex items-center">
            <Link
              href={
                mobileOS === "iOS"
                  ? "https://apps.apple.com/vn/app/on-live-tv/id6505140172"
                  : "https://play.google.com/store/apps/details?id=vn.vtvlive.ontv.a"
              }
              className="text-white bg-blue-600 rounded-[15px] text-[12px] whitespace-nowrap px-3 py-2"
            >
              Tải xuống
            </Link>
          </div>
        </div>
      </nav>
    </>
  )
}
